import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';

import { getMinStdOptions } from '@/module/MinimalStandard/model/MinStdQuery';

export const Route = createFileRoute('/_auth/minimal-standards/_layout/report/gather/_gather')({
  component: RouteComponent,
  loaderDeps: ({ search: { userId } }) => ({ userId }),
  loader: async ({ context: { queryClient }, deps: { userId } }) => {
    if (userId == null) {
      return null;
    }

    const data = await queryClient.ensureQueryData(getMinStdOptions(userId));

    if (data == null) {
      throw redirect({ to: '/minimal-standards', search: true });
    }

    return data;
  },
});

function RouteComponent() {
  return <Outlet />;
}
